import React, { useEffect, useState } from "react";
import axios from 'axios';
import Cookies from 'js-cookie';
import { translate } from "../Services/translation";

export default function MCSSettingsContainer() {

    const [activeContainer, setActiveContainer] = useState(1);
    const [uploadInfoText, setUploadInfoText] = useState("Upload file");
    const [uploaded, setUploaded] = useState(false);
    const [settings, setSettings] = useState({});
    const [showSave, setShowSave] = useState(false);

    const maxSize = 1073741824;

    useEffect(() => {
        getFile();
        getSettings();
    }, []);

    const changeActiveContainer = (value) => { 
        setActiveContainer(value);
    }
    const toggleDebugMode = (e) => {
        let valToSet = e == 1 ? false : true;
        var settingsCopy = settings;
        settingsCopy.debugEnabled = valToSet;
        setSettings(settingsCopy)
        setDebugMode(valToSet);
    }

    const getFile = () => {
        return axios.post(`/api/mcs/getfile`)
            .then(res => {
                if (res.data) {
                    setUploaded(true);
                    setUploadInfoText(translate("mcs.fileuploaded"));
                }
                else {
                    setUploaded(false);
                    setUploadInfoText(translate("mcs.uploadfile"));
                }
            })
    }

    const getSettings = () => {
        return axios.get(`/api/mcs/getSettings`)
            .then(res => {
                if (res.data != "") {
                    setSettings(res.data);
                }
            })
    }

    const clearMemoryCache = () => {
        return axios.post(`/api/mcs/clearcache`);
    }
    const setDebugMode = (val) => {

        const headers = {
            'Content-Type': 'application/json'
        }

        var debugModel = { debugEnabled: val };
        return axios.post(`/api/mcs/toggleDebug`, debugModel, headers);
    }

    const updateSettings = (id, domain) => {
        var idModel = {  
            Name: id,
            Id: "mcs.analyticsWebsiteId",
        }
        var domainModel = {
            Name: domain,
            Id: "mcs.websitedomain"
        }
        var model = [idModel, domainModel];

        return axios.post(`/api/mcs/setsettings`, model)
            .then(res => {
                var settingCopy = settings;

                if (res.data) {
                    if(id !== settings.analyticsWebsiteId){
                        settingsCopy.analyticsWebsiteId = id;                       
                    }if(domain !== settings.websiteDomain){
                        settingsCopy.websiteDomain = domain;
                    }
                    setSettings(settingsCopy)
                    setShowSave(false);
                }
                else{
                    settingsCopy.analyticsWebsiteId = "";
                    settingsCopy.websiteDomain = "";
                    setSettings(settingsCopy);
                    setShowSave(false);
                    setWebSiteIdWarning(translate("mcs.analyticserror"))
                }
            })
    }

    const setRootFolder = (value) => {
        var model = {
            Name: value,
            Id: "mcs.rootfoldername",
        }
        return axios.post(`/api/mcs/setrootfoldername`, model)
            .then(res => {
                var settingsCopy = settings;
                if (res.data) {
                    settingsCopy.rootFolderName = value;
                    setShowSave(false);
                }
                else{
                    settingsCopy.rootFolderName = "";
                    setShowSave(false);
                }
                setSettings(settingsCopy);
            })
    }

    const setRootFolderRedirectPath = (value) => {
        var model = {
            Name: value,
            Id: "mcs.rootfolderredirectpath",
        }
        return axios.post(`/api/mcs/setrootfolderredirectpath`, model)
            .then(res => {
                var settingsCopy = settings;
                if (res.data) {
                    settingsCopy.rootFolderDirectPath = value;
                    setShowSave(false);
                }
                else{
                    settingsCopy.rootFolderDirectPath = "";
                    setShowSave(false);
                }
                setSettings(settingsCopy);
            })
    }

    const handleFile = (e, location) => {
        e.stopPropagation();
        e.preventDefault();
        var file = e.target.files[0];
        if (file != null) {
            if (file.size <= maxSize) {
                if (location == "import") {
                    postImportFile(file);
                }
                else {
                    postUploadFile(file);
                }
            }
            else {
                setWarning(translate("mcs.filesizeerror"));
            }
        }
    } 

    const postUploadFile = (file) => {
        return axios.post(`/api/mcs/upload`, file)
            .then(res => {
                if (res.data) {
                    setUploaded(true);
                    setUploadInfoText(translate("mcs.fileuploaded"));
                }
                else {
                    setUploaded(false);
                    setUploadInfoText(translate("mcs.analyticserror"));
                }
            })
    }

    const runClickEvent = () => {
        document.getElementById('mcs-upload-input').click()
    }

    const changeTextField = (value, key) => {
        var settingsCopy = settings;
        if(key == 'id'){
            if (value == "") {
                setShowSave(false);
            }
            else if (!showSave) {
                setShowSave(true);
            }
            settingsCopy.websiteDomain = value;
        }else{
            if (value == "") {
                setShowSave(false);
            }
            else if (!showSave) {
                setShowSave(true);
            }
            settingsCopy.websiteDomain = value;
        }
        setSettings(settingsCopy)
    }

    const changeRootFolderTextField = (value) => {
        var settingsCopy = settings;
        if (value == "") {
            setShowSave(false);
        }
        else if (!showSave) {
            setShowSave(true);
        }
        settingsCopy.rootFolderName;
        setSettings(settingsCopy);
    }

    const changeRootFolderRedirectPath = (value) => {
        var settingsCopy = settings;
        if (value == "") {
            setShowSave(false);
        }
        else if (!showSave) {
            setShowSave(true);
        }
        settingsCopy.rootFolderDirectPath = value;
        setSettings(settingsCopy);
    }

    const changeRootFolderName = (save) => {
        if (save) {
            setRootFolder(settings.rootFolderName);
            setRootFolderRedirectPath(settings.rootFolderDirectPath);
        }
        else{
            setShowSave(false);
            getRootFolder();
        }
    }

    const changeSettings = (save) => {
        if(save){
            updateSettings(settings.analyticsWebsiteId, settings.websiteDomain);
        }
        else{
            setShowSave(false);
            getWebsiteId();
        }
    }

    function getCookie(name) {
        const cookieString = document.cookie;
        const cookies = cookieString.split('; ');
    
        for (const cookie of cookies) {
            const [cookieName, cookieValue] = cookie.split('=');
            if (cookieName === name) {
                return decodeURIComponent(cookieValue);
            }
        }
        return null; // Cookie not found
    }

    return (
        <>
            <div className="mcs-settings-container center-container">
                <div className="row">
                    <div className="mcs-settings-container__settings-wrapper page-panel">
                        <div className="mcs-settings-container__topic-container col-6">
                            <ul className="mcs-settings-container__topic-list">
                                <li className={activeContainer == 1 ? "active no-select" : "no-select"} onClick={() => changeActiveContainer(1)}>{translate("mcs.searchconsole")}<i className="fas fa-chevron-right"></i></li>
                                <li className={activeContainer == 2 ? "active no-select" : "no-select"} onClick={() => changeActiveContainer(2)}>{translate("mcs.analytics")}<i className="fas fa-chevron-right"></i></li>
                                <li className={activeContainer == 3 ? "active no-select" : "no-select"} onClick={() => changeActiveContainer(3)}>{translate("mcs.rootfolder")}<i className="fas fa-chevron-right"></i></li>
                            </ul>
                            <input type="checkbox" id="toggleDebug" onChange={(event) => toggleDebugMode(event.target.value)} value={getCookie("debugEnabled")} checked={getCookie("debugEnabled") ? "checked" : null}/>
                            <label htmlFor="toggleDebug">Toggle dubug mode</label>
                            <input type="button" className={"mcs-settings-container__upload-button mcs-settings-container__upload-button--alternate"} value={"Clear cache"} style={{ cursor: "pointer" }} onClick={() => clearMemoryCache()} />
                        </div>
                        <div className="mcs-settings-container__result-container col-6">
                            {activeContainer == 1 &&
                                <div className="mcs-settings-container__result-wrapper mcs-settings-container__console-wrapper column">
                                    <h4>{translate("mcs.consolefile")}</h4>
                                    <input type="button" className={uploaded ? "mcs-settings-container__upload-button mcs-settings-container__upload-button--uploaded" : "mcs-settings-container__upload-button"} value={uploadInfoText} style={{ cursor: "pointer" }} onClick={() => runClickEvent()} />
                                    <input type="file" id="mcs-upload-input" style={{ display: "none" }} onChange={(event) => handleFile(event, "upload")} />
                                    {uploaded && <i className="fas fa-check"></i>}
                                </div>
                            }
                            {activeContainer == 2 &&
                                <>
                                    <div className="mcs-settings-container__result-wrapper mcs-settings-container__analytics-wrapper column">
                                        <h4>{translate("mcs.websiteid")}</h4>
                                        <input onChange={(event) => changeTextField(event.target.value, 'id')} value={settings.analyticsWebsiteId} />
                                        <h4>{translate("mcs.domain")}</h4>
                                        <input onChange={(event) => changeTextField(event.target.value, 'domain')} value={settings.websiteDomain} />
                                        {showSave &&
                                        <div className="mcs__edited-container mcs__container col-12 columns"><div onClick={() => changeSettings(true)}>{translate("mcs.save")}</div><div onClick={() => changeSettings(false)}>{translate("mcs.cancel")}</div></div>
                                        }
                                    </div>
                                </>
                            }
                            {activeContainer == 3 &&
                                <>
                                <div className="mcs-settings-container__result-wrapper mcs-settings-container__rootFolder-wrapper column">
                                    <h4>{translate("mcs.rootfoldername")}</h4>
                                    <input onChange={(event) => changeRootFolderTextField(event.target.value)} value={settings.rootFolderName} />
                                    <h4>{translate("mcs.rootfolderredirectpath")}</h4> 
                                    <input onChange={(event) => changeRootFolderRedirectPath(event.target.value)} value={settings.rootFolderDirectPath} />
                                    {showSave &&
                                    <div className="mcs__edited-container mcs__container col-12"><div onClick={() => changeRootFolderName(true)}>{translate("mcs.save")}</div><div onClick={() => changeRootFolderName(false)}>{translate("mcs.cancel")}</div></div>
                                    }
                                </div>
                            </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

